<div *ngIf="routePartCMR">
    <div *ngIf="formatDocumentQRCode" class="codeqr" (click)="onClickQR()">
        <div class="img">
            <div *ngIf="showcount" class="countinfo">{{ count }}</div>
            <img [src]="formatDocumentQRCode" />
        </div>
        <div class="title">{{routePartCMR.routePartCMRKey}}</div>
    </div>
</div>
